import React from 'react';
import { Loader2 } from 'lucide-react';

export interface Props extends React.HTMLAttributes<SVGSVGElement> {}

export const Spinner = React.forwardRef<HTMLDivElement, Props>(({ className, ...props }, ref) => (
  <Loader2 className={`motion-safe:animate-spin ${className}`} {...props} />
));

Spinner.displayName = 'Spinner';
